var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"quiz"}},[_c('iframe',{staticClass:"typeform-widget",attrs:{"data-hj-allow-iframe":"","src":"https://spiritt.io/apply-to-spiritt/eGhp9wrR?s=spmail"}})])
}]

export { render, staticRenderFns }